import React from 'react';
import { ANIMATION_PROPS } from './animation_const.js';
import AdvancedSetting from '../component/AdvancedSetting.jsx';
import MapboxHelpTooltip from '../component/MapboxHelpTooltip.jsx';
import AnimationTypeSetting from './AnimationTypeSetting.jsx';
import Select from "../../../../common/Select.jsx";

function AnimationSetting({updateField, data, index}) {
    const {id, type, animationName, advancedSetting} = data;
    return (                  
      <div className='w-100'>
        <label className="col-xs-12">
          {ANIMATION_PROPS.animationName.title}
          <MapboxHelpTooltip description={ANIMATION_PROPS.animationName.description} />
          <input
            type="text"
            className="form-control"
            value={animationName}
            onChange={(e) => updateField(`animationFields.${index}.animationName`, e.target.value)}
          />
        </label>
        <label className='col-xs-12'>
          {ANIMATION_PROPS.type.title}
          <MapboxHelpTooltip description={ANIMATION_PROPS.type.description} />
          <Select
            value={type || ANIMATION_PROPS.type.default}
            options={ANIMATION_PROPS.type.options}
            onChange={(v) => updateField(`animationFields.${index}.type`, v)}
          />
        </label>
        <AnimationTypeSetting index={index} animationField={data} updateField={updateField} />
        <AdvancedSetting
          update={(val) => updateField(`animationFields.${index}.advancedSetting`, val)} 
          title={ANIMATION_PROPS.advancedSetting.title}
          description={ANIMATION_PROPS.advancedSetting.description}
          setting={advancedSetting}
        />
      </div>);
}

export default AnimationSetting;